module.exports = __webpack_public_path__ + "static/media/two.7bbd7aa6.svg";